export default "__VITE_ASSET__9499c020__"